import { Flex } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { NavLink, useLocation } from "react-router-dom";
import useNavlinks, { navlinkType } from "../hooks/useNavlinks";
import React from "react";

type NavbarProps = {
  preview?: boolean;
  couponURL?: string | null;
  hideTabs?: string[];
};

const Navbar: React.FC<NavbarProps> = ({
  hideTabs = [],
  preview = false,
  couponURL,
}: NavbarProps) => {
  const { navlinkItems } = useNavlinks();
  const { pathname } = useLocation();
  const linkItems = navlinkItems.filter((navlink) => !hideTabs?.includes(navlink.key));
  return (
    <Flex
      justify={linkItems.length > 2 ? 'space-between' : 'space-around'}
      style={
        preview
          ? {
            padding: "4px 15px 4px 15px",
            height: "fit-content",
            borderTop: "1px solid #D7DEE4",
          }
          : undefined
      }
      className="h-[40px] z-50 relative px-2"
      align="center"
    >
      {linkItems.map((navlink: navlinkType, index) => (
        <NavLink
          key={index}
          to={
            preview
              ? "#"
              : (navlink.key === "/coupon" && couponURL) || navlink.key
          }
          style={{
            color: "var(--app-foreground-color)",
            fill: "var(--app-foreground-color)",
          }}
          className="flex flex-col items-center justify-center w-[64px] h-[40px] fill-current"
        >
          {pathname.includes(navlink.key)
            ? navlink.iconActive
            : preview && navlink.key === "/profile"
              ? navlink.iconActive
              : navlink.iconInactive}
          <Paragraph
            style={{ color: "var(--app-foreground-color)" }}
            className="menu-item py-1"
          >
            {navlink.label}
          </Paragraph>
        </NavLink>
      ))}
    </Flex>
  );
};
export default Navbar;
